import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { IImage } from '../../models/IScreen';
import { IRaster } from './ProjectShowcaseRaster';

function ProjectShowcaseRasterRow(props: IRaster) {

    const populateImages = props.items.map((image: IImage, index: number) => {
        return <Col key={index}><Image fluid className="showcase-raster" src={image.src} alt={image.alt} /></Col>
    })

    return (
        <Row>
            {populateImages}
        </Row>
    );
}

export default ProjectShowcaseRasterRow;